import React from "react";
import one from "../assets/logo-icon.png";
import two from "../assets/logo-text.png";
import axios from "axios";
export default class DashHome extends React.Component{
     static ab = null;
    constructor(prop) {
        super(prop);
    this.state = {
        message: '',
        answer: '',
    }
    DashHome.ab = this;
    }

     componentDidMount() {
            DashHome.loadData();
    }

     static loadData(){
           axios.get(`http://kopakwetu.co.tz:8000/api/get/data/`+sessionStorage.getItem("uid")).then((response) => {
       console.table(response.data.data)
             console.log(response.data.data.message)
             this.ab.setState({
                 message: response.data.data.message,
             })
    });

    }

     jow(){
        var message = document.getElementById('message').value;
        var sender = sessionStorage.getItem("uid")
        var data = {
            'sender':sender,
            'message':message,
        }

        axios.post(`http://kopakwetu.co.tz:8000/api/post/data`,data).then((response) => {
              DashHome.loadData();
             this.setState({
                 answer: response.data.answer
             })
           console.log('response')

            const text = response.data.answer
	const utterance = new SpeechSynthesisUtterance(text);
	window.speechSynthesis.speak(utterance);
        });

    }



    render() {
        return (
            <div className={'jose_container'}  style={{position:'absolute', top:72, width:'100%', height:'100vh'}}>
                <div style={{color:'#111'}}>
                   <div style={{ marginLeft:'10px'}}>
                      <span><b><i>Last Qn asked: </i></b>{this.state.message}.</span>
                  </div>
                  <span style={{ marginLeft:'10px'}}>{this.state.answer}</span>
                </div>

                <div className={'footer'}>
                     <div>
                         <div className="searchbox-container">
                             <input  id={'message'} type="search" className="searchbox" name="search" autoComplete="off"
                                    placeholder="Ask any question here..."/>
                             <button onClick={()=>this.jow()} type="submit" className="searchbutton fa fa-search"></button>
                         </div>
                     </div>
                </div>
            </div>
        );
    }
}